import React, { useContext, useRef } from 'react';
import './endcap.scss';
import { Carousel } from '@thd-olt-component-react/core-ui';
import {
  useStoreId,
  useStore,
} from '@thd-nucleus/experience-context';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import {
  QueryProvider,
  QueryContext,
} from '@thd-nucleus/data-sources';
import { ImpressionProvider, useImpression } from '@thd-olt-component-react/impression';
import { NoProductsMessage } from './NoProductsMessage';
import { CategoryCarouselPropType, CategoryCarouselDefaultPropType } from './Helper';

const CategoryCarousel = ({
  endCapData,
  exclude,
  categoryName,
  categoryImageURL,
  categoryURL,
  categoryShopAllLink,
  channel,
  displayImageOnMobileWeb,
  title,
  componentName,
  entryId,
  hideCarouselArrows
}) => {
  const carouselRef = useRef(null);
  const storeId = useStoreId();
  const { storeZip: zipCode } = useStore();
  const { isClientResolved } = useContext(QueryContext);
  const localStoreId = useRef(storeId);
  const hasProducts = (endCapData?.products || []).filter((product) => {
    return (exclude || []).indexOf(product.itemId) === -1;
  }).length !== 0;

  const handleClickedProduct = (productIndex) => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger(
        `${componentName}.click`,
        productIndex
      );
    }
  };
  const properUrl = categoryShopAllLink !== '' ? categoryShopAllLink : categoryURL;
  const showCategoryBlock = categoryImageURL && properUrl;
  const dataSources = endCapData?.products?.[0]?.dataSources === 'personalizedDeals'
    ? 'personalizedDeals'
    : 'topDeals';
  const cacheKey = dataSources && dataSources === 'personalizedDeals'
    ? 'personalized-deals-child'
    : 'top-deals-child';

  let impressionName = title.replace(/\s/g, '');
  let impressionCategoryName = categoryName.replace(/\W+/g, '');

  const impressionData = {
    id: entryId || '',
    component: 'Endcap',
    name: impressionName || '',
    type: 'product',
    position: '',
    category: impressionCategoryName || ''
  };

  return (
    <ImpressionProvider data={impressionData}>
      <div>
        {!hasProducts && (
          <NoProductsMessage
            categoryName={categoryName !== 'All' ? categoryName : ''}
            imageUrl={categoryImageURL}
            url={properUrl}
            title={title}
          />
        )}
        {hasProducts && (
          <div className="endcap-section products-section">
            {showCategoryBlock && (
              <div className="category-block">
                <div className="category-icon">
                  <div className="category-image">
                    <img src={categoryImageURL} width="1" height="1" alt="" />
                  </div>
                  <a href={properUrl} className="shop-all events-widget__link">
                    <p>Shop All {categoryName !== 'All' ? categoryName : ''}</p>
                  </a>
                </div>
              </div>
            )}
            <div
              id={'digital-endcap-' + endCapData.catName}
              ref={carouselRef}
              className="digital-endcap"
            >
              <QueryProvider
                dataSource={endCapData?.products?.[0]?.dataSources}
                dataSources={endCapData?.products?.[0]?.dataSources}
                defaultVariables={{
                  storeId: localStoreId.current,
                  zipCode,
                  skipSpecificationGroup: true
                }}
                cacheKey={cacheKey}
              >
                <Carousel
                  slidesPerView={1}
                  breakpoints={{
                    xs: {
                      slidesPerView: showCategoryBlock ? 1 : 2,
                      slidesPerGroup: showCategoryBlock ? 1 : 2,
                    },
                    sm: {
                      slidesPerView: showCategoryBlock ? 1 : 2,
                      slidesPerGroup: showCategoryBlock ? 1 : 2,
                    },
                    md: {
                      slidesPerView: showCategoryBlock ? 2 : 3,
                      slidesPerGroup: showCategoryBlock ? 2 : 3,
                    },
                    lg: {
                      slidesPerView: showCategoryBlock ? 3 : 4,
                      slidesPerGroup: showCategoryBlock ? 3 : 4,
                    },
                    xl: {
                      slidesPerView: showCategoryBlock ? 4 : 5,
                      slidesPerGroup: showCategoryBlock ? 4 : 5,
                    },
                  }}
                  initialSlide={0}
                  hideCarouselArrows={hideCarouselArrows}
                >
                  {(displayImageOnMobileWeb && channel === 'mobile'
                    ? [
                      <div>
                        <div className="mobile-image">
                          <img
                            src={categoryImageURL}
                            height="1"
                            width="1"
                            alt="1"
                          />
                        </div>
                      </div>,
                    ]
                    : []
                  ).concat(
                    (endCapData?.products || [])
                      .filter((product) => {
                        return (exclude || []).indexOf(product.itemId) === -1;
                      })
                      .map((product, productIndex) => (
                        <div key={productIndex}>
                          <div
                            id={'top-deals__wrapper-' + productIndex}
                            className="endcap-pod-wrapper"
                          >
                            <ProductPod
                              onClick={() => handleClickedProduct(productIndex)}
                              itemId={product.itemId}
                              brandTitleMaxLine={2}
                              storeId={localStoreId.current}
                              hideShippingInfo
                              podType="simple"
                              mobilePodType="simple"
                              showFavoritesCount
                              brand="inline"
                              position={productIndex}
                              key={productIndex}
                              noATCFulfillment
                            />
                          </div>
                        </div>
                      ))
                  )}
                </Carousel>
              </QueryProvider>
            </div>
          </div>
        )}
      </div>
    </ImpressionProvider>
  );
};

CategoryCarousel.displayName = 'CategoryCarousel';
CategoryCarousel.propTypes = CategoryCarouselPropType;
CategoryCarousel.defaultProps = CategoryCarouselDefaultPropType;

export { CategoryCarousel };
